// extracted by mini-css-extract-plugin
export default {"scroll":"table-root_scroll__sE40o","table-container":"table-root_table-container__Zf7Vw"};